// Packages
import React, { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Table,
  Spinner,
  Button,
  Input,
  InputGroup,
} from "reactstrap";
import axios from "axios";
import { BsSearch } from "react-icons/bs";
// Utils
import {
  catchHandler,
  collaborationTypesLabels,
  getRequestHeaders,
} from "../utils";
// Components
import Pagination from "../components/Pagination";
// Styling
import "./UserSubscriptions.css";
import { statusLabels } from "../utils/constants";

const UserSubscriptions = React.memo((props) => {
  const { state: locationState = {} } = useLocation();
  const { pageNumber = 1 } = locationState;
  const [loading, setLoading] = useState(false);
  const [subscriptions, setUserSubscriptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(pageNumber);
  const [totalCount, setTotalCount] = useState(0);
  const history = useHistory();
  const catchHandlerBinded = catchHandler.bind(null, history);
  const [searchValue, setSearchValue] = useState("");
  const [searchTriggerValue, setSearchTriggerValue] = useState("");

  const getData = useCallback((currentPage, searchTriggerValue) => {
    setLoading(true);

    axios
      .get(
        `/api/user-subscriptions/list-subscriptions`,
        getRequestHeaders(
          Object.assign(
            {
              page: currentPage,
            },
            searchTriggerValue && {
              search: searchTriggerValue,
            }
          )
        )
      )
      .then((res) => {
        const { data = {} } = res;
        const { items, totalCount } = data;
        setUserSubscriptions(items);
        setTotalCount(totalCount);
      })
      .catch(catchHandlerBinded)
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    getData(currentPage, searchTriggerValue);
  }, [currentPage, searchTriggerValue]);

  const getRows = useCallback(
    () =>
      subscriptions.length ? (
        subscriptions.map(
          ({
            _id,
            location,
            subject,
            course,
            enrollmentYear,
            admissionYear,
            graduationYear,
            collaborationType,
            blocked,
            graduated,
          }) => (
            <tr key={`user-subscriptions-row-${_id}`}>
              <td>{location?.name}</td>
              <td>{subject?.name}</td>
              <td>{course?.name}</td>
              <td>{enrollmentYear}</td>
              <td>{admissionYear}</td>
              <td>{graduationYear}</td>
              <td>{collaborationTypesLabels[collaborationType]}</td>
              <td>{blocked || graduated ? statusLabels.INACTIVE : statusLabels.ACTIVE}</td>
            </tr>
          )
        )
      ) : (
        <tr>
          <td colSpan={8} className="text-center">
            <span>Fara rezultat</span>
          </td>
        </tr>
      ),
    [subscriptions]
  );

  const onSearchChange = useCallback((event) => {
    const { target = {} } = event;
    const { value } = target;
    setSearchValue(() => value);
  }, []);

  const handleSearch = useCallback(
    (event) => {
      const { type, key } = event;

      if (type === "click" || (type === "keyup" && key === "Enter")) {
        setSearchTriggerValue(searchValue);
        setCurrentPage(1);
      }
    },
    [searchValue]
  );

  const onAddClick = useCallback(() => {
    history.push(`${history.location.pathname}/add`);
  }, [history]);

  return (
    <Container className="mt-5 mb-5" style={{ maxWidth: "1400px" }}>
      <Row className="mt-5">
        <Col className="d-flex justify-content-between align-items-center">
          <span className="">
            <h3>Inrolari ({totalCount})</h3>
          </span>
          <span>
            <Button
              disabled={loading}
              className=""
              color="primary"
              size="sm"
              onClick={onAddClick}
            >
              Inrolare noua
            </Button>
          </span>
        </Col>
      </Row>
      <Row className="mt-1 justify-content-end">
        <Col className="col-3 d-inline-flex">
          <InputGroup>
            <Input
              type="text"
              placeholder="Search..."
              onChange={onSearchChange}
              onKeyUp={handleSearch}
              value={searchValue}
            />
            <Button
              disabled={loading}
              color="secondary"
              size="sm"
              onClick={handleSearch}
            >
              <BsSearch />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <Row className="mt-1">
        <Col>
          <Table hover>
            <thead>
              <tr>
                <th>Locatie</th>
                <th>Disciplina</th>
                <th>Curs</th>
                <th>An Inscriere</th>
                <th>An Admitere</th>
                <th>An Absolvire</th>
                <th>Tip Colaborare</th>
                <th>Status curs</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={8} className="text-center">
                    <Spinner
                      color="dark"
                      style={{ width: "3rem", height: "3rem" }}
                    />
                  </td>
                </tr>
              ) : (
                getRows()
              )}
            </tbody>
          </Table>
          <Pagination
            currentPage={currentPage}
            totalCount={totalCount}
            onSetPage={setCurrentPage}
          />
        </Col>
      </Row>
    </Container>
  );
});

export default UserSubscriptions;
